jQuery(document).ready(commonInit);

function commonInit() {
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupBanner();
	setupHero();
	setupVideoBackgrounds();
	setupSmoothScroll();
	setupScrollTriggers();
	setupScrollClass();
	setupMergeNextBlock();
	
}

function setupMobileMenu() {
	
	jQuery("#mobile-nav").mmenu({
		"slidingSubmenus": false,
		"offCanvas": {
			"position": "bottom"
		},
		"navbar":{
			"add": false
		}
	}, {
	
		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
		}
	});
	
}

function setupColumns() {
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupBanner() {
	
	var banner = document.getElementById('global-alert');
	var closeButton = document.getElementById('close-alert');
	var html = document.getElementsByTagName('html')[0];
	
	if (!banner || !html) {
		return false;
	}
	
	var bannerHasBeenClosed = sessionStorage.getItem('bannerHasBeenClosed');
	
	if (!bannerHasBeenClosed) {
		html.classList.add('enable-global-alert');
	}
	
	if (closeButton) {
		closeButton.addEventListener('click', function() {
			html.classList.remove('enable-global-alert');
			sessionStorage.setItem('bannerHasBeenClosed', true);
		});
	}
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname) {
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;


function setupHero() {

	if(jQuery('#hero-carousel:not(.slick-initialized)').length) {

		jQuery('#hero-carousel:not(.slick-initialized)').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 1,
			slidesPerRow: 1,
			dots: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			fade: true,
			easing: "linear",
			pauseOnHover: false,
			infinite: true,
			draggable: false,
			swipe: true,
			adaptiveHeight: false
		});
	
	}
	
	// Optimize hero video loading
	const heroVideo = document.querySelector('.hero-video');
	if (heroVideo) {
		// Show content immediately, don't wait for video
		document.body.classList.add('page-loaded');
		
		// Handle video load errors gracefully
		heroVideo.addEventListener('error', function() {
			console.warn('Hero video failed to load - poster image will remain visible');
		}, { once: true });
	} else {
		// No video, add page-loaded class after initial paint
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				document.body.classList.add('page-loaded');
			});
		});
	}

}

function setupVideoBackgrounds() {
	// Handle all video background sections
	const sectionVideos = document.querySelectorAll('.section-video');
	
	sectionVideos.forEach(video => {
		// Handle video load errors gracefully
		video.addEventListener('error', function() {
			console.warn('Section video failed to load - poster image will remain visible');
		}, { once: true });
	});
}

// Smooth scroll to on-page anchors with 100px offset
function setupSmoothScroll(){ 
	var anchorOffset = 150;
	
	// Delegate clicks on anchors that start with '#'
	jQuery(document).on('click', 'a[href^="#"], a[href^="/#"]', function(e){
		var href = jQuery(this).attr('href');

		// Skip empty hash or explicitly opted-out links
		if(!href || href === '#' || jQuery(this).is('[data-no-smooth]')) return;

		// Only handle same-page links
		var url = new URL(this.href, window.location.origin);
		if (url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
		if (url.hostname !== window.location.hostname) return;

		var targetId = url.hash;
		if(!targetId) return;

		var $target = jQuery(targetId);
		if(!$target.length) {
			// Fallback to name attribute
			$target = jQuery('[name="' + targetId.substring(1) + '"]');
		}

		if($target.length){
			e.preventDefault();
			var top = Math.max(0, $target.offset().top - anchorOffset);
			jQuery('html, body').stop(true).animate({ scrollTop: top }, 700, 'swing');
			history.pushState(null, null, targetId);
		}
	});

	// Handle page load with hash in URL
	if(window.location.hash){
		var $target = jQuery(window.location.hash);
		if(!$target.length) {
			$target = jQuery('[name="' + window.location.hash.substring(1) + '"]');
		}
		if($target.length){
			setTimeout(function(){
				var top = Math.max(0, $target.offset().top - anchorOffset);
				jQuery('html, body').stop(true).animate({ scrollTop: top }, 700, 'swing');
			}, 100);
		}
	}
}

function setupScrollTriggers(){

	const elements = document.querySelectorAll('.scroll-alert:not(.set-up)');
	
	if ('IntersectionObserver' in window) {
	
		const options = {
			root: null,
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		};
		
		var observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('active');
				}
			});
		}, options);
		
		elements.forEach(element => {
			element.classList.add('set-up');
			observer.observe(element);
		});
		
	} else {
		
		for(var i=0; i<elements.length; i++) {
			elements[i].classList.add('set-up');
			elements[i].classList.add('active');	
		}
		
	}

}

function setupScrollClass() {
	// Add scroll event listener using jQuery
	jQuery(window).on('scroll', function() {
		// Check if page is scrolled
		if (jQuery(window).scrollTop() > 0) {
			// Add not-top class when scrolled down
			jQuery('body').addClass('not-top');
		} else {
			// Remove not-top class when at the top
			jQuery('body').removeClass('not-top');
		}
	});
	
	// Initial check on page load
	if (jQuery(window).scrollTop() > 0) {
		jQuery('body').addClass('not-top');
	}
}

function setupMergeNextBlock() {
	
	var $blocks = jQuery('.wp-block-group.merge-next-block');
	if (!$blocks.length) return;
	
	function applyMergeStyles() {
		$blocks.each(function() {
			var $block = jQuery(this);
			var totalHeight = $block.outerHeight(); // full height including padding
			var halfHeight = totalHeight / 2;
			var remSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
			var basePadding = remSize * 7; // 7rem in pixels
			
			// Set negative margin on the merge-next-block
			$block.css('margin-bottom', -halfHeight + 'px');
			
			// Set padding on the next sibling
			var $nextBlock = $block.next('div[class*="wp-block"]');
			if ($nextBlock.length) {
				$nextBlock.css('margin-top', '0');
				// For video-bg-section, apply padding to child .video-bg div
				if ($nextBlock.hasClass('wp-block-video-bg-section')) {
					$nextBlock.find('.video-bg').css('padding-top', (halfHeight + basePadding) + 'px');
				} else {
					$nextBlock.css('padding-top', (halfHeight + basePadding) + 'px');
				}
			}
		});
	}
	
	applyMergeStyles();
	
	// Re-apply on window resize (debounced)
	var resizeTimer;
	jQuery(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(applyMergeStyles, 250);
	});
	
}
